import * as FullStory from '@fullstory/browser'

const sendFullStoryEvent = (eventName, eventProperties) => {
  return FullStory.event(eventName, eventProperties)
}

export default sendFullStoryEvent



// WEBPACK FOOTER //
// ./src/utils/analyticsHelpers/sendFullStoryEvent.js